module.exports = {
	init: () => {
		$(function () {
			if($('.block.gallery').length < 1){
				return;
			}
			var easing = "linear",
				duration = 500,
				coords = [
					[ // 1
						{
							targets: ".item-1",
							scale: 1,
							translateX: "0%",
							translateY: "0%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-2",
							scale: 0.5,
							translateX: "150%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
							  translateX: "-50%",
							  translateY: "150%", 
              }
						},
						{
							targets: ".item-3",
							scale: 0.5,
							translateX: "150%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
							  translateX: "50%",
							  translateY: "150%", 
              }
						},
						{
							targets: ".item-4",
							scale: 0.5,
							translateX: "250%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
							  translateX: "-50%",
                			  translateY: "250%"
              }
						},
						{
							targets: ".item-5",
							scale: 0.5,
							translateX: "250%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
							  translateX: "250%", 
              
              }
						},
					],
					[ // 2
						{
							targets: ".item-1",
							scale: 0.5,
							translateX: "150%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-2",
							scale: 1,
							translateX: "0%",
							translateY: "0%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-3",
							scale: 0.5,
							translateX: "150%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-4",
							scale: 0.5,
							translateX: "250%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-5",
							scale: 0.5,
							translateX: "250%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
					],
					[ // 3
						{
							targets: ".item-1",
							scale: 0.5,
							translateX: "-50%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-2",
							scale: 0.5,
							translateX: "-50%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-3",
							scale: 1,
							translateX: "50%",
							translateY: "0%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-4",
							scale: 0.5,
							translateX: "250%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-5",
							scale: 0.5,
							translateX: "250%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
					],
					[ // 4
						{
							targets: ".item-1",
							scale: 0.5,
							translateX: "-50%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-2",
							scale: 0.5,
							translateX: "-50%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-3",
							scale: 0.5,
							translateX: "50%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-4",
							scale: 1,
							translateX: "100%",
							translateY: "0%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-5",
							scale: 0.5,
							translateX: "50%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
					],
					[ // 5
						{
							targets: ".item-1",
							scale: 0.5,
							translateX: "-50%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-2",
							scale: 0.5,
							translateX: "-50%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-3",
							scale: 0.5,
							translateX: "50%",
							translateY: "-50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-4",
							scale: 0.5,
							translateX: "50%",
							translateY: "50%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
						{
							targets: ".item-5",
							scale: 1,
							translateX: "100%",
							translateY: "0%",
							duration: duration,
							easing: easing,
              mobile:{
              
              }
						},
					],
				];

      		const isMobileView = $(window).width() < 768;

			// Set the first position on ready
			coords[0].forEach(function (value) {

				if(isMobileView){
					let switchedTransform = {
						translateX: value.translateY,
						translateY: value.translateX
					}
					value = {...value, ...switchedTransform}
				}
			
				anime(value);
			});

			// Set new position on click
			$(".block.gallery .item").click(function () {
				$(this).parents('.items').find('.item').removeClass("active");
				$(this).addClass("active");
				coords[$(this).index()].forEach(function (value) {
					if(isMobileView){
					let switchedTransform = {
						translateX: value.translateY,
						translateY: value.translateX
					}
					value = {...value, ...switchedTransform}
					}

					anime(value);
				});
			});
		});
	},
};
